export default {
	toPrice (config) {
		const def = {
			pre: '$',
			locale: 'en-US',
			fix: 2,
			...config && config.toPrice || {}
		};

		return (num, pre = def.pre, locale = def.locale, fix = def.fix) => {
			const number = typeof num === 'number' ? num : parseFloat(num);
			return pre + number.toLocaleString(locale, {
				maximumFractionDigits: fix,
				minimumFractionDigits: fix
			});
		};
	},

	toTitleCase () {
		return str => {
			if (!str) return '';
			return str.toLowerCase().replace(/  +/g, ' ').split(' ').map(word => {
				return word.replace(word[0], word[0].toUpperCase());
			}).join(' ');
		};
	},

	truncate (config) {
		const def = {
			limit: 30,
			trail: '...',
			...config && config.truncate || {}
		};

		return (str, limit = def.limit, trail = def.trail) => {
			if (str.length > limit) {
				return `${str.substring(0, (limit - trail.length))}${trail}`;
			}
			return str;
		};
	}
};
